//Unform e componentes
import Swal from "sweetalert2";

//Util
import { fn_isValidNumber } from "@/common/utils/util";

/*
 * Apresenta uma mensagem pop-up simples com botão Fechar
 */
export function Message(title, text, footer) {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      html: text,
      footer: footer,
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      returnFocus: true,
      confirmButtonColor: "var(--thema-btn-primary-background)",
      confirmButtonText: "Fechar",
    }).then(() => {
      resolve(); // Não há escolha, apenas fecha
    });
  });
}

/*
 * Apresenta uma mensagem pop-up de confirmação
 */
//@returnFocus: false = não devolve o foco ao elemento anterior ao fechar (quando abre outra tela depois da confirmação:
//a devolução acontece depois de fechar a mensagem e tiraria o foco da tela aberta)
export function MessageConfirm(
  title,
  text,
  footer,
  useSimNao,
  returnFocus = true,
) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: title,
      html: text,
      footer: footer,
      icon: "question",
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      returnFocus: returnFocus,
      confirmButtonColor: "var(--thema-btn-primary-background)", //"#3085d6",
      cancelButtonColor: "var(--thema-btn-secondary-background)", //"#d33",
      confirmButtonText: useSimNao == true ? "Sim" : "Confirmar",
      cancelButtonText: useSimNao == true ? "Não" : "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(1);
      } else {
        resolve(0);
      }
    });
  });
}

/*
 * Apresenta uma mensagem pop-up com as opções Sim, Não e Cancelar. O foco inicial fica no Sim.
 * O nome do botão cancelar pode ser informado (padrão "Fechar").
 * Retorna 1 (Sim), 0 (Não) ou -1 (Cancelar)
 */
export function MessageConfirmSimNaoCancelar(
  title,
  text,
  footer,
  nomeBotaoCancelar,
) {
  return new Promise((resolve) => {
    Swal.fire({
      title: title,
      html: text,
      footer: footer,
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      returnFocus: true,
      focusConfirm: true,
      confirmButtonColor: "var(--thema-btn-primary-background)",
      denyButtonColor: "#db324d",
      cancelButtonColor: "var(--thema-btn-secondary-background)",
      confirmButtonText: "Sim",
      denyButtonText: "Não",
      cancelButtonText: nomeBotaoCancelar || "Fechar",
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(1);
      } else if (result.isDenied) {
        resolve(0);
      } else {
        resolve(-1);
      }
    });
  });
}

/*
 * Apresenta uma mensagem pop-up de confirmação de exclusão
 * @param footer: opcional. Texto apresentado no rodapé da mensagem
 */
export function MessageConfirmDelete(
  complementoTexto,
  continuacaoTexto,
  footer,
) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: `Confirma a exclusão ${continuacaoTexto || ""}`.concat(
        complementoTexto ? " <br/> (" + complementoTexto + ")" : "",
      ),
      //text: "",
      footer: footer,
      icon: "question",
      showCancelButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      returnFocus: true,
      confirmButtonColor: "#db324d",
      cancelButtonColor: "var(--thema-btn-secondary-background)",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(1);
      } else {
        resolve(0);
      }
    });
  });
}

/*
 * Apresenta uma tela pop-up com um campo de input para informar um valor
 */
export function MessageInputText(
  title,
  label,
  defaultValue,
  {
    tipo_valor = "S",
    decimal = 0,
    maxLength,
    valorMin,
    valorMax,
    placeholder,
    permiteNull,
  },
  nomeBotaoConfirm,
) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: title,
      input: "text",
      inputLabel: label ? label : null,
      inputValue: defaultValue ? defaultValue : "",
      inputPlaceholder: placeholder ? placeholder : "",
      inputAttributes: {
        maxlength: maxLength ? maxLength : 60,
        //autocomplete: false, //nao funcionou
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "var(--thema-btn-primary-background)",
      cancelButtonColor: "var(--thema-btn-secondary-background)",
      confirmButtonText: nomeBotaoConfirm || "Confirmar",
      cancelButtonText: "Cancelar",

      didOpen: () => {
        const input = Swal.getInput();
        if (input) {
          input.select();

          //Se permitir casas decimais, limita o campo
          if (tipo_valor == "N") {
            if (decimal > 0) {
              input.addEventListener("input", () => {
                let valor = input.value;

                //Remove tudo que não seja número ou vírgula
                valor = valor.replace(/[^\d,]/g, "");

                //Permite apenas uma vírgula
                const partes = valor.split(",");
                if (partes.length > 2) {
                  valor = `${partes[0]},${partes.slice(1).join("")}`;
                }

                //Limita a quantidade de casas decimais
                if (valor.includes(",")) {
                  const [inteiro, casas] = valor.split(",");

                  valor = `${inteiro},${casas.substring(0, decimal)}`;
                }

                input.value = valor;
              });
            } else {
              //Sem casas decimais: permite somente números
              input.addEventListener("input", () => {
                input.value = input.value.replace(/\D/g, "");
              });
            }
          }
        }
      },

      preConfirm: (inputValue) => {
        if (!inputValue && !permiteNull) {
          Swal.showValidationMessage("Informe o valor");
        }
        //Se o tipo for numérico
        else if (tipo_valor == "N") {
          if (inputValue) {
            //Converte vírgula decimal para ponto para validação
            const valorNumerico = inputValue.replace(",", ".");

            //Verifica se o valor é numérico
            if (!fn_isValidNumber(valorNumerico)) {
              Swal.showValidationMessage("Valor deve ser numérico");
            }
            //Se o valor for numérico, valida min e max
            else {
              //Valida valor mínimo, caso tenha sido informado
              if (valorMin) {
                if (Number(valorNumerico) < Number(valorMin)) {
                  Swal.showValidationMessage(
                    `Valor mínimo deve ser ${valorMin}`,
                  );
                }
              }

              //Valida valor máximo, caso tenha sido informado
              if (valorMax) {
                if (Number(inputValue) > Number(valorMax)) {
                  Swal.showValidationMessage(
                    `Valor máximo deve ser ${valorMax}`,
                  );
                }
              }
            }
          }
        }

        return inputValue;
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error,
        });
        reject(error);
      });
  });
}

/*
 * Apresenta uma tela pop-up com um campo de input ou select para informar/selecionar um valor
 */
export function MessageField(
  title,
  label,
  {
    type = "TXT", // "TXT" ou "SEL"
    tipo_valor = "S",
    maxLength,
    valorMin,
    valorMax,
    placeholder,
    permiteNull,
    options = [], // usado quando for "SEL"
    defaultValue,
  },
  nomeBotaoConfirm,
) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: title,
      input: type === "SEL" ? "select" : "text",
      inputLabel: label || null,
      inputValue: defaultValue || null,
      inputPlaceholder: placeholder || "",
      inputOptions:
        type === "SEL"
          ? options.reduce((acc, opt) => {
              // opções no formato {value, label}
              acc[opt.value] = opt.label;
              return acc;
            }, {})
          : undefined,
      inputAttributes:
        type === "TXT"
          ? {
              maxlength: maxLength || 60,
            }
          : undefined,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "var(--thema-btn-primary-background)",
      cancelButtonColor: "var(--thema-btn-secondary-background)",
      confirmButtonText: nomeBotaoConfirm || "Salvar",
      cancelButtonText: "Cancelar",

      preConfirm: (inputValue) => {
        if (!inputValue && !permiteNull) {
          Swal.showValidationMessage("Informe o valor");
        }

        // validações extras só para texto numérico
        if (type === "TXT" && tipo_valor == "N") {
          //Se o valor não for numérico
          if (!fn_isValidNumber(inputValue)) {
            Swal.showValidationMessage("Valor deve ser numérico");
          }
          //Se o valor for numérico, valida min e max
          else {
            const num = Number(inputValue);

            if (valorMin && num < valorMin) {
              Swal.showValidationMessage(`Valor mínimo deve ser ${valorMin}`);
            }

            if (valorMax && num > valorMax) {
              Swal.showValidationMessage(`Valor máximo deve ser ${valorMax}`);
            }
          }
        }

        return inputValue;
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error,
        });
        reject(error);
      });
  });
}

/*
 * Apresenta uma mensagem pop-up com um campo de radio para informar uma opção
 */
export function MessageRadio(
  title,
  label,
  options = {}, // { valor1: "Label 1", valor2: "Label 2" } Ex: { 1: "Código", 2: "Nome" }
  defaultValue = null,
  nomeBotaoConfirm,
) {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: title,
      input: "radio",
      inputLabel: label || null,
      inputOptions: options,
      inputValue: defaultValue,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonColor: "var(--thema-btn-primary-background)",
      cancelButtonColor: "var(--thema-btn-secondary-background)",
      confirmButtonText: nomeBotaoConfirm || "Confirmar",
      cancelButtonText: "Cancelar",

      preConfirm: (inputValue) => {
        if (!inputValue) {
          Swal.showValidationMessage("Selecione uma opção");
        }
        return inputValue;
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          resolve(result.value);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error,
        });
        reject(error);
      });
  });
}

/*
 * Apresenta uma mensagem pop-up com um campo para selecionar um arquivo de determinada extensão.
 */
export function MessageInputFile(extensoes, nomeBotaoConfirm) {
  return new Promise((resolve, reject) => {
    let fileRet = null;

    // Converte o array de extensões em uma string para o atributo "accept"
    const extensoesPermitidas =
      extensoes && Array.isArray(extensoes)
        ? extensoes.map((ext) => `.${ext}`).join(",")
        : "*";

    Swal.fire({
      title: "Selecione o arquivo",
      input: "file",
      inputAttributes: {
        accept: extensoesPermitidas,
      },
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: nomeBotaoConfirm || "Confirmar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "var(--thema-btn-primary-background)", //"#3085d6",
      cancelButtonColor: "var(--thema-btn-secondary-background)", //"#d33",

      allowOutsideClick: false,
      allowEscapeKey: false,

      preConfirm: (file) => {
        if (!file) {
          Swal.showValidationMessage("Selecione o arquivo");
          return false;
        } else {
          fileRet = file;
        }
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          resolve(fileRet);
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error,
        });
        reject(error);
      });
  });
}

/*
 * Apresenta uma mensagem pop-up com um campo select e um campo para selecionar um arquivo de determinada extensão.
 */
export function MessageInputFileWithSelect(extensoes, opcoesSelect) {
  return new Promise((resolve, reject) => {
    let fileRet = null;
    let selectedOption = null;

    // Converte o array de extensões em uma string para o atributo "accept"
    const extensoesPermitidas =
      extensoes && Array.isArray(extensoes)
        ? extensoes.map((ext) => `.${ext}`).join(",")
        : "*";

    Swal.fire({
      title: "Selecione o arquivo",
      input: "file",
      inputAttributes: {
        accept: extensoesPermitidas,
      },
      html: `
        <select id="selectInput" style="margin-bottom: 10px; padding: 6px; border: 1px solid #ccc; border-radius: 4px; width: 100%;">
          ${opcoesSelect
            .map(
              (opcao) =>
                `<option value="${opcao.value}">${opcao.label}</option>`,
            )
            .join("")}
        </select>
      `,
      showCancelButton: true,
      showLoaderOnConfirm: true,

      confirmButtonText: "Importar",
      cancelButtonText: "Cancelar",

      confirmButtonColor: "var(--thema-btn-primary-background)",
      cancelButtonColor: "var(--thema-btn-secondary-background)",

      allowOutsideClick: false,
      allowEscapeKey: false,

      preConfirm: (file) => {
        const selectInput = document.getElementById("selectInput");

        if (!file) {
          Swal.showValidationMessage("Selecione o arquivo");
          return false;
        }
        if (!selectInput.value) {
          Swal.showValidationMessage("Selecione uma opção");
          return false;
        }

        fileRet = file;
        const valor = selectInput.value;
        selectedOption = opcoesSelect.find((op) => op.value == valor);
      },
    })
      .then((result) => {
        if (result.isConfirmed) {
          resolve({ file: fileRet, selectedOption });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: error,
        });
        reject(error);
      });
  });
}

/*
 * Apresenta a tela com a senha gerada e o botão para copiar a senha
 * Obs: A cópia pelo botão (comando navigator.clipboard.writeText) só funciona com conexão segura (HTTPS) ou localhost.
 */
export function MessageViewSenha(senha, title, texto, footer) {
  return new Promise((resolve) => {
    const permiteCopiar = !!navigator.clipboard; // só existe em https/localhost

    Swal.fire({
      title: title,
      html: `
      <div style="display: flex; align-items: center; gap: 8px; justify-content: center; margin-bottom: 10px;">
      <code id="senha-texto" style="font-size: 16px; padding: 4px 8px; background: #f1f1f1; border-radius: 4px;">${senha}</code>
      ${
        permiteCopiar
          ? `<button onclick="copiarSenha()"  title="Copiar senha" style="border-radius: 4px; padding: 4px; color:var(--thema-btn-primary-color); background: var(--thema-btn-primary-background); cursor: pointer;">
                  Copiar
                </button>`
          : ""
      }
      
        </div>
        ${texto}
      `,
      footer: footer,

      confirmButtonText: "Fechar",
      confirmButtonColor: "var(--thema-btn-secondary-background)",

      showCloseButton: true,

      allowOutsideClick: false,
      allowEscapeKey: false,

      didOpen: () => {
        window.copiarSenha = () => {
          const senha = document.getElementById("senha-texto").innerText;
          navigator.clipboard.writeText(senha).then(() => {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Senha copiada!",
              showConfirmButton: false,
              timer: 1500,
            });
          });
        };
      },

      didClose: () => {
        resolve();
      },
    });
  });
}

/*
 * Apresenta mensagem indicando se o retorno é válido ou não
 */
export function MessageValido(mensagem, valido) {
  Swal.fire({
    toast: true,
    position: "top-end",
    icon: valido ? "success" : "error",
    title: mensagem,
    showConfirmButton: false,
    timer: 1500,
  });
}

/*
 * Apresenta a mensagem como toast
 */
export function MessageToast(tipo, mensagem) {
  const tipos = {
    success: { icon: "success", background: "#51A351" },
    error: { icon: "error", background: "#db324d" },
    warning: { icon: "warning", background: "#F89406" },
    info: { ocpm: "info", background: "#2F96B4" },
  };

  Swal.fire({
    html: mensagem.replace(/\n/g, "<br>"),
    icon: tipos[tipo].icon || tipos.info.icon,
    background: tipos[tipo].background || tipos.info.background,
    color: "#fff",

    customClass: {
      popup: "swal2-popup-custom",
    },

    toast: true, //importante para manter estilo compacto
    width: "650px",
    position: "top", //"top-center", "top-end",
    timer: 4000, //fecha automático
    timerProgressBar: true,

    showConfirmButton: false,

    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
}
